import { DataBean } from "../DataBean";

export class TrainingRequest extends DataBean {

    public async getTrainingRequestCatalogPorPropiedades(properties: any, maxRows: number): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "java.util.List_getTrainingRequestCatalogPorPropiedades_java.util.Map_Number",
            [properties, maxRows]
        );
    }

    public async getTrainingRequestRender(page: number, rows: number, props: Record<string, any>): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.advantage.shared.Report_getTrainingRequestRender_Number_Number_java.util.Map",
            [page, rows, props]
        );
    }

    public async getTrainingRequest(idtrainingrequest: number): Promise<any> {
        return this.getCustomService("PayRollERP", "com.orange.people.payroll.bean.TrainingRequest_getTrainingRequest_Number", [idtrainingrequest]);
    }

    public async deleteTrainingRequest(idtrainingrequest: number): Promise<any> {
        return this.getCustomService("PayRollERP", "boolean_deleteTrainingRequest_Number", [idtrainingrequest]);
    }

    public async updateTrainingRequest(bean: any): Promise<any> {
        return this.getCustomService(
            "PayRollERP",
            "com.orange.people.payroll.bean.TrainingRequest_updateTrainingRequest_com.orange.people.payroll.bean.TrainingRequest",
            [
                {
                    DataBeanProperties: bean,
                    DataBeanName: "com.orange.people.payroll.bean.TrainingRequest",
                },
            ]
        );
    }

}
